import { createApiAction } from "helpers/api";

export const updateAppNavigation = createApiAction({
  method: "PUT",
  endpoint: () => "/administration/app_navigation",
  baseType: "ADMINISTRATION/APP_NAVIGATION/UPDATE",
});
